import { StoreData, getSdgName } from '../getPageContext'

export const buildSdgContent = (data?: StoreData): Record<string, unknown> => {
  if (!data?.sdg) return {}

  const { sdg, locale } = data
  const { previousQuarter, previousYear } = sdg

  if (!previousQuarter && !previousYear) return {}

  const buildGoals = (
    changePercent: { id: number; value: number }[] | undefined
  ) => {
    if (!changePercent) return []
    return changePercent.map((p) => ({
      id: p.id,
      name: getSdgName(p.id, locale),
      changePercent: Math.round(p.value * 10) / 10,
    }))
  }

  const result: Record<string, unknown> = {
    selectedQuarter: data.selectedQuarter,
    sdgComparison: {},
  }

  const comparison: Record<string, unknown> = {}

  if (previousQuarter) {
    comparison.previousQuarter = {
      label: previousQuarter.graphTitle || 'Previous Quarter',
      goals: buildGoals(previousQuarter.changePercent),
    }
  }

  if (previousYear) {
    comparison.previousYear = {
      label: previousYear.graphTitle || 'Previous Year',
      goals: buildGoals(previousYear.changePercent),
    }
  }

  result.sdgComparison = comparison
  return result
}
